import React from 'react'
import { connect } from 'react-redux'
import RecentResults from '../recentResult'
import ImportantInfo from '../importantInfo'
import test from '../../images/ic-results.png';
import '../../css/styles.css';
import { PENDING, NEGATIVE, POSITIVE, EQUIVOCAL, NORESULT, CANCELLED, INVALID } from '../../api/mappers/labResultMapper'
import { LANG_FR } from '../../util/language_v3';

import BackButton from '../backButton'
import { formatDate } from '../../util/util'
import Select from 'react-select';

const NOT_AVAILABLE = "Not available";

const getResultText = (result, strings) => {
    switch (result.toLowerCase()) {
        case POSITIVE:
            return strings.TEST_POSITIVE;
        case NEGATIVE:
            return strings.TEST_NEGATIVE;
        case PENDING:
            return strings.TEST_PENDING;
        case NORESULT:
            return strings.TEST_NORESULT;
        case EQUIVOCAL:
            return strings.TEST_EQUIVOCAL;
        case CANCELLED:
            return strings.TEST_CANCELLED;
        default:
            return strings.TEST_INVALID;
    }
}

const ResultSelector = (props) => {
    const { onChange, selectedResult, labResults, language, strings } = props;

    const options = labResults.map(result => ({ value: result, label: formatDate(result.resultDate, language) + " - " + getResultText(result.result, strings) }));

    const styles = {
        option: (provided) => ({
            ...provided,
            'font-weight': 'bold'
        }),
        control: (provided) => ({
            ...provided,
            'font-weight': 'bold'
        })
    }

    return !labResults ? null : (
        <div className="result-selector">
            <Select
                isSearchable={false}
                value={options.filter((option) => option.value === selectedResult)}
                onChange={onChange}
                options={options}
                styles={styles}
            />
        </div>
    );
}

const getLabAddress = (result, strings) => {
    if (result.labName === NOT_AVAILABLE || result.labAddressStreet === NOT_AVAILABLE || result.labAddressCity === NOT_AVAILABLE || result.labAddressProv === NOT_AVAILABLE || result.labAddressPostalCode === NOT_AVAILABLE || result.labAddressCountry === NOT_AVAILABLE) {
        return strings.NOT_AVAILABLE;
    } else {
        return [result.labName.replace('\\n', "\n"), result.labAddressStreet, result.labAddressCity + " " + result.labAddressProv + " " + result.labAddressPostalCode, result.labAddressCountry];
    }
}

const ResultBox = (props) => {
    const { selectedResult, strings, language, onChange, labResults, deviceType } = props;

    if (selectedResult != null) {
        return (
            <div className="col-12 col-md-8 order-2 order-sm-2 order-md-1 ml-auto ml-md-auto">
                <div className="row">
                    <div className="col-12 noMargin">
                        <BackButton target={'/app'} />
                        <div className="testName">
                            <div class="testIcon"><img src={test} width="25" /></div>
                            <h4>{strings.RESULT_BOX_HEADER}</h4>
                        </div>
                        <div></div>
                        <div className="col-12 col-md-8 order-2 order-sm-2 order-md-1 ml-auto ml-md-auto">&nbsp;</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mb-2" >
                        <h6>{strings.HISTORIC_TEST_HEADER}</h6>
                        <ResultSelector onChange={onChange} selectedResult={selectedResult} labResults={labResults} language={language} strings={strings} />
                    </div>
                </div>
                {<RecentResults
                    language={language}
                    strings={strings}
                    result={selectedResult.result}
                    rawResult={selectedResult.rawResult}
                    type={selectedResult.type}
                    collectionDate={selectedResult.collectionDate}
                    resultDate={selectedResult.resultDate}
                    collectionSite={selectedResult.collectionSite}
                    labAddress={getLabAddress(selectedResult, strings)}
                    deviceType={deviceType}
                />}
                <ImportantInfo selectedResult={selectedResult} isModal={false} />
            </div>
        );
    } else {
        return (
            <div className="col-12 col-md-8 order-2 order-sm-2 order-md-1 ml-auto ml-md-auto">
                <div className="row">
                    <div className="col-12">
                        {strings.NO_RESULT}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        strings: state.language.strings,
        deviceType: state.api.deviceType,
        language: state.language.language
    }
}

const ConnectedResultBox = connect(
    mapStateToProps
)(ResultBox);
export default ConnectedResultBox;
